import { Box, BoxProps, Heading } from 'grommet'
import { CancelIcon, DeleteIcon, EditIcon } from '../../../assets/svgs'
import { palette } from '../../../themes/palette'

export type IModalHeader = {
  onClose: () => void
  title?: string
  pad?: BoxProps['pad']
  onEdit?: () => void
  onDelete?: () => void
}

export function ModalHeader({ onClose, title, onEdit, onDelete, pad = 'medium' }: IModalHeader) {
  return (
    <Box
      align="center"
      alignSelf={!title ? 'end' : 'stretch'}
      as={'header'}
      border={title ? { side: 'bottom' } : { style: 'hidden' }}
      direction="row"
      flex={false}
      gap={'20px'}
      justify="between"
      pad={pad}
    >
      {title && (
        <Heading color="black" level={2} margin="none" size="20px" weight="400">
          {title}
        </Heading>
      )}
      <Box direction="row" gap={'5px'}>
        {onEdit && (
          <Box onClick={onEdit}>
            <EditIcon fill={palette.asparagus} />
          </Box>
        )}
        {onDelete && (
          <Box onClick={onDelete}>
            <DeleteIcon />
          </Box>
        )}
        <Box onClick={() => onClose()}>
          <CancelIcon />
        </Box>
      </Box>
    </Box>
  )
}
